module.exports = __webpack_public_path__ + "img/defuser.bd73b544.svg";